import React from 'react';
import SrokiDogovorov from '../../components/reports/srokidogovorov/SrokiDogovorov'

function Page(props) {
    return (
        <>
          <SrokiDogovorov />
        </>
    );
}

export default Page;